import styled from 'styled-components/macro'

export const InvoiceMerchantTitle = styled.header<{ fullScreenPopup?: boolean }>`
  width: 100%;
  background: ${(props) => props.theme.invoiceTitle.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 68px;
  padding-bottom: ${(props) => (props.fullScreenPopup ? '13px' : '0')};

  & h1 {
    color: ${(props) => props.theme.invoiceTitle.h1Color};
    font-weight: 600;
    font-style: ${(props) => props.theme.invoiceTitle.h1FontStyle};
    font-size: ${(props) => props.theme.invoiceTitle.h1FontSize};
    line-height: 40px;
    margin: 0 14px;
  }

  & h2 {
    color: ${(props) => props.theme.text};
    font-style: italic;
    font-size: 20px;
    line-height: 28px;
    margin: 0 14px;
  }
`

export const InvoiceMerchantTitleIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 68px;
  background: #fff;

  & svg {
    height: 40px;
    width: 100%;
  }

  & img {
    margin: 16px;
  }
`
